import React, { Component } from 'react';
import { connect } from 'react-redux';
import history from '../../../history';
import actions from '../../../actions';
import AvailabilityTable from './table';
import { withRefreshTableOnFilterChange } from '../common/decorators';
import { TDispatch } from '../../../reducers';
import { TFreelancerData, TMeta, TUser } from '../../../types';

type TAvailabilityProps = {
    load: (searchParams: URLSearchParams, isInitialLoad?: boolean) => void;
    content: TFreelancerData[];
    meta: TMeta;
    fetching: boolean;
    notification: never;
    user: TUser;
    selectedFreelancers: TFreelancerData[];
    setSelectedFreelancers: (allSelectedFreelancers: TFreelancerData[]) => void;
}

type TAvailabilityState = {
    freelancers: TFreelancerData[];
    user: TUser;
}


const MIN_SEARCH_LEN = 3;

// @ts-ignore
@withRefreshTableOnFilterChange
class Availability extends Component<TAvailabilityProps, TAvailabilityState> {
    componentDidMount() {
        const currentUrlParams = new URLSearchParams(history.location.search);
        // second parameter is needed to trigger isInitialLoad
        this.props.load(currentUrlParams, true);
    }

    render() {
        const currentUrlParams = new URLSearchParams(history.location.search);
        let pages = -1;
        let showPaginationBottom = false;

        if (this.props.content && this.props.meta) {
            pages = Math.ceil(this.props.meta.count / 20);
            showPaginationBottom = this.props.meta.count > 20;
        }

        return (
            <AvailabilityTable
                data={this.props.content}
                pages={pages}
                showPaginationBottom={showPaginationBottom}
                loading={this.props.fetching}
                notification={this.props.notification}
                user={this.props.user}
                meta={this.props.meta}
                reloadData={() => this.props.load(currentUrlParams)}
                selectedFreelancers={this.props.selectedFreelancers}
                setSelectedFreelancers={this.props.setSelectedFreelancers}
                currentUrlParams={currentUrlParams}
            />
        );
    }
}

const mapStateToProps = (state: TAvailabilityState) => ({
    ...state.freelancers,
    user: state.user,
});

const mapDispatchToProps = (dispatch: TDispatch) => ({
    load: (searchParams: URLSearchParams, isInitialLoad = false) => {
        const searchValue = searchParams.get('search');
        if (isInitialLoad || !searchValue || searchValue.length >= MIN_SEARCH_LEN) {
            dispatch(actions.loadFreelancers(searchParams));
        }
    },
    setSelectedFreelancers: (items: TFreelancerData[]) =>
        dispatch(actions.setSelectedFreelancers(items)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Availability);
